import React from "react";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "./style.scss";
import "../../../../style/buttons.scss";
import { weekDays } from "../../../models/Data/Weekdays";
import { addDays, format } from "date-fns";
import SingleExercise from "../single-exercise";
import { ExerciseScheduleList } from "../../../models/ExerciseScheduleList";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { useTranslation } from "react-i18next";

interface IProps {
  today: Date;
  dateFromState: Date;
  exercisesList: ExerciseScheduleList;
  loading: boolean;
  onRefreshExercises: () => void;
}

const ScheduleDesktop: React.FC<IProps> = ({ today, dateFromState, exercisesList, loading, onRefreshExercises }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <table className="exercise-schedule-desktop">
          <thead>
            <tr>
              <th className="hourCol" />
              {weekDays.map((item, index) => (
                <th
                  className={
                    format(today, "dd.MM") === format(addDays(dateFromState, index), "dd.MM") ? "today days" : "days"
                  }
                  key={index}
                >
                  <span>{t(item)}</span>
                  <b>{format(addDays(dateFromState, index), "dd.MM")}</b>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 24 }).map((_, hour) => {
              const hasExercises = Object.keys(exercisesList).some((day) => {
                const events = exercisesList[day as keyof ExerciseScheduleList];
                return events.some((e) => {
                  const eventHour = new Date(e.startTime).getHours();
                  return eventHour === hour;
                });
              });

              if (!hasExercises) {
                return null; // Skip rendering the row if no exercises for this hour
              }

              return (
                <tr key={hour}>
                  <td>{`${hour}:00`}</td>
                  {Object.keys(exercisesList).map((day) => {
                    const events = exercisesList[day as keyof ExerciseScheduleList];
                    const hourEvents = events.filter((e) => {
                      const eventHour = new Date(e.startTime).getHours();
                      return eventHour === hour;
                    });

                    return (
                      <td key={day}>
                        {hourEvents.length > 0 ? (
                          <div>
                            {hourEvents.map((event, index) => (
                              <div className="singleone" key={index}>
                                <SingleExercise exercise={event} onRefreshExercises={onRefreshExercises} />
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </LoadableComponent>
    </React.Fragment>
  );
};

export default ScheduleDesktop;
